/*!
 *   Copyright 2022  SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
/*!
 *   Copyright 2022-2024 SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
:host {
  width: 100%;
  height: 100%;
}
:host .button-wrapper {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
:host .button-wrapper button.discovery-btn {
  margin: 0.25rem 0.125rem;
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  font-size: var(--warp-view-button-font-size, 1rem);
  border: 1px solid var(--warp-view-button-border-color, #004eff);
  padding: var(--warp-view-button-padding, 0.375rem 0.75rem);
  color: var(--warp-view-button-label-color, #ffffff);
  background-color: var(--warp-view-button-bg-color, #004eff);
  min-width: var(--warp-view-button-width, auto);
  border-radius: var(--warp-view-button-border-radius, 0.25rem);
}
:host .discovery-btn-group button.discovery-btn {
  margin: 0.25rem 0;
  color: var(--warp-view-button-inactive-label-color, #004eff);
  background-color: var(--warp-view-button-inactive-bg-color, #ffffff);
}
:host .discovery-btn-group button.discovery-btn.active {
  color: var(--warp-view-button-label-color, #ffffff);
  background-color: var(--warp-view-button-bg-color, #004eff);
}
:host .discovery-btn-group button.discovery-btn:hover {
  color: var(--warp-view-button-label-color, #ffffff);
  background-color: var(--warp-view-button-bg-color, #004eff);
}
:host .discovery-btn-group button.discovery-btn:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
:host .discovery-btn-group button.discovery-btn:not(:first-of-type) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}